import SignalsTooltipTableView from "app/pages/sales-intelligence/sub-modules/signals/components/tooltips/shared/SignalsTooltipTableView/SignalsTooltipTableView";
import styled from "styled-components";
import { tooltipBasicTextStyles } from "app/pages/sales-intelligence/sub-modules/signals/components/tooltips/shared/styles";
import { colorsPalettes } from "@similarweb/styles";

export const StyledIntentTooltipText = styled.a`
    ${tooltipBasicTextStyles};

    &:hover,
    &:active {
        cursor: pointer;
        color: ${colorsPalettes.blue[500]};
        background-color: ${colorsPalettes.blue[100]};
    }
`;

export const StyledTooltipTableView = styled(SignalsTooltipTableView)`
    & .MiniFlexTable-cell {
        height: 34px;
    }
`;
